/**
 * useServiceHealth: one /api/health check when a screen opens, for showing which data sources are
 * off. Null until it answers or when it fails, so an unknown state never disables anything.
 */

import { useEffect, useState } from 'react';
import type { HttpClient } from '../api/httpClient';
import { type ExternalApiHealth, readExternalApis } from '../serviceHealth';

export interface UseServiceHealthOptions {
  httpClient: HttpClient;
  enabled?: boolean;
}

export function useServiceHealth({
  httpClient,
  enabled = true,
}: UseServiceHealthOptions): ExternalApiHealth | null {
  const [health, setHealth] = useState<ExternalApiHealth | null>(null);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    httpClient
      .get<unknown>('/api/health')
      .then((body) => {
        if (!cancelled) setHealth(readExternalApis(body));
      })
      .catch(() => {
        if (!cancelled) setHealth(null);
      });
    return () => {
      cancelled = true;
    };
  }, [httpClient, enabled]);

  return health;
}
